import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {
  @Input() float: string;

  constructor() { }

  ngOnInit() {
  }

  getClass() {
    if (this.float !== undefined) {
      return 'row float-' + this.float;
    } else {
      return 'row';
    }
  }

}
